import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import WeekChart from '../../components/TimeSheet/WeekChart';
import CardHeader from '../../components/CardHeader';
import { TimeSheet } from './types';

type Props = {
  timeSheet: TimeSheet;
};

const WeekChartCard: React.FC<React.PropsWithChildren<Props>> = ({
  timeSheet,
}) => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader>{t('timeTracking.graphs.week.title')}</CardHeader>
      <Card.Body>
        <WeekChart
          startDate={timeSheet.flair__Start_Date__c}
          tracked={timeSheet.trackedTime}
        />
      </Card.Body>
    </Card>
  );
};

export default WeekChartCard;
